import { render, staticRenderFns } from "./TabsContent.vue?vue&type=template&id=b523c3c8&"
import script from "./TabsContent.vue?vue&type=script&lang=ts&"
export * from "./TabsContent.vue?vue&type=script&lang=ts&"
import style0 from "./TabsContent.vue?vue&type=style&index=0&id=b523c3c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports